// TODO: undefined gefällt mir hier nicht
export const initialExecutionStateMealy = {
    currentNode: undefined,
    lastTransition: undefined,
    lastChar: '',
    lastCharIndex: 0,
    lastTransitionOutput: '',
};
export const initialExecutionStateDEA = {
    input: '',
    executionStates: [],
    isAccepted: false,
};
